import type { MessageDescriptor } from 'react-intl';
import type { MusicVideoEffectFamily } from 'fym-shared/src/music24/musicVideoEffects';
import { storyMessages as messages } from '../../messages/storyMessages';

/** The effect families in the order of the design (d1, d2). */
export const EFFECT_FAMILY_ORDER: readonly MusicVideoEffectFamily[] = ['lyric', 'title', 'transition', 'shot'];

/** The name of an effect family on a style card. */
export const EFFECT_FAMILY_NAMES: Readonly<Record<MusicVideoEffectFamily, MessageDescriptor>> = {
  lyric: messages.familyLyric,
  title: messages.familyTitle,
  transition: messages.familyTransition,
  shot: messages.familyShot,
};

/** The one-line hint of an effect family: what it does in the video. */
export const EFFECT_FAMILY_HINTS: Readonly<Record<MusicVideoEffectFamily, MessageDescriptor>> = {
  lyric: messages.familyLyricHint,
  title: messages.familyTitleHint,
  transition: messages.familyTransitionHint,
  shot: messages.familyShotHint,
};

/**
 * The families with one family switched on or off, in the order of the design. Pure.
 * Any subset is allowed, the empty one too: the director then writes no effect.
 */
export function toggleEffectFamily(
  families: readonly MusicVideoEffectFamily[],
  family: MusicVideoEffectFamily
): MusicVideoEffectFamily[] {
  const isOn = families.includes(family);
  return EFFECT_FAMILY_ORDER.filter((item) => (item === family ? !isOn : families.includes(item)));
}
